module.exports = __webpack_public_path__ + "img/2.8b6206f5.jpg";